import { Link, useParams } from "react-router-dom";
import styles from "./assets/scss/home.module.scss";
import { useEffect } from "react";

export default function Home() {
  const data = useParams();
  
  useEffect(() => {
    if(data["*"] && (data["*"] !== "dashboard" && data["*"] !== "/dashboard" &&  data["*"] !== "dashboard/")){
      window.location.pathname = "/dashboard"
    }
  }, [data]);
  
  const scenesData = [
    {
      id: 2,
      link: "/configurator/2",
      imgSrc: "thumbnails/EDGEWOOD_44_FP9044.jpg",
      title: "Edge Wood",
    },
    {
      id: 3,
      link: "/configurator/3",
      imgSrc: "thumbnails/SPITFIRE_64_DC_FLUSH_MAD6721.jpg",
      title: "Spitfire Ac",
    },
    {
      id: 4,
      link: "/configurator/4",
      imgSrc: "thumbnails/SPITFIRE_48_DC_FLUSH_LK_And_Lens.jpg",
      title: "Spitfire Dc",
    },
    {
      id: 5,
      link: "/configurator/5",
      imgSrc: "thumbnails/OBVI_FP3050.jpg",
      title: "OBVI",
    },
    {
      id: 6,
      link: "/configurator/6",
      imgSrc: "thumbnails/AMPED_FP7634.jpg",
      title: "AMPED",
    },
    {
      id: 7,
      link: "/configurator/7",
      imgSrc: "thumbnails/AIRE_DELUXE_52-LIGHT_FP6285B.jpg",
      title: "AIRE DELUXE 52",
    },
    {
      id: 8,
      link: "/configurator/8",
      imgSrc: "thumbnails/KWAD_52_FP7652.jpg",
      title: "KWAD",
    },
    {
      id: 9,
      link: "/configurator/9",
      imgSrc: "thumbnails/CELANO_V2_FP8062B.jpg",
      title: "CELANO",
    },
    {
      id: 10,
      link: "/configurator/10",
      imgSrc: "thumbnails/DOREN_FP8533.jpg",
      title: "DOREN",
    },
    {
      id: 11,
      link: "/configurator/11",
      imgSrc: "thumbnails/LEVON_AC_FP7910.jpg",
      title: "LEVON AC",
    },
    {
      id: 12,
      link: "/configurator/12",
      imgSrc: "thumbnails/PAGET_FP6837.jpg",
      title: "PAGET",
    },
    {
      id: 13,
      link: "/configurator/13",
      imgSrc: "thumbnails/BARLOW_FP6807.jpg",
      title: "BARLOW",
    },
    {
      id: 14,
      link: "/configurator/14",
      imgSrc: "thumbnails/KLEAR_FPD6858.jpg",
      title: "KLEAR",
    },
    {
      id: 15,
      link: "/configurator/15",
      imgSrc: "thumbnails/BRAWN_FPD6605.jpg",
      title: "BRAWN",
    },
    {
      id: 16,
      link: "/configurator/16",
      imgSrc: "thumbnails/PENDRY_56_FPD6865.jpg",
      title: "PENDRY",
    },
    {
      id: 17,
      link: "/configurator/17",
      imgSrc: "thumbnails/PYRAMID_FP8406.jpg",
      title: "PYRAMID",
    },
    {
      id: 18,
      link: "/configurator/18",
      imgSrc: "thumbnails/GLEAM_FP8404.jpg",
      title: "GLEAM",
    },
    {
      id: 19,
      link: "/configurator/19",
      imgSrc: "thumbnails/HENRY_FP8519.jpg",
      title: "HENRY",
    },
    {
      id: 20,
      link: "/configurator/20",
      imgSrc: "thumbnails/KWARTET_FPS8553.jpg",
      title: "KWARTET",
    },
    {
      id: 21,
      link: "/configurator/21",
      imgSrc: "thumbnails/KLINCH_44_FPS7681.jpg",
      title: "KLINCH",
    },
    {
      id: 22,
      link: "/configurator/22",
      imgSrc: "thumbnails/HUGH_44_FPS8332B.jpg",
      title: "HUGH",
    },
    {
      id: 23,
      link: "/configurator/23",
      imgSrc: "thumbnails/KUTE_52_FPD8534.jpg",
      title: "KUTE",
    },
    {
      id: 24,
      link: "/configurator/24",
      imgSrc: "thumbnails/SCULPTAIRE_FP8511.jpg",
      title: "SCULPTAIRE",
    },
    {
      id: 25,
      link: "/configurator/25",
      imgSrc: "thumbnails/GLIDEAIRE_FPD8520.jpg",
      title: "GLIDEAIRE",
    },
    {
      id: 26,
      link: "/configurator/26",
      imgSrc: "thumbnails/XENO_DAMP_FP6728BBN.jpg",
      title: "XENO DAMP",
    },
    {
      id: 27,
      link: "/configurator/27",
      imgSrc: "thumbnails/LEVON_DC_CUSTOM_52_MAD7912B.jpg",
      title: "LEVON DC CUSTOM",
    },
    {
      id: 28,
      link: "/configurator/28",
      imgSrc: "thumbnails/WRAP_CUSTOM_44_MAD8530.jpg",
      title: "WRAP CUSTOM",
    },
    {
      id: 29,
      link: "/configurator/29",
      imgSrc: "thumbnails/TRIAIRE_CUSTOM_44_MAD8514.jpg",
      title: "TRIAIRE CUSTOM",
    },
    {
      id: 30,
      link: "/configurator/30",
      imgSrc: "thumbnails/ODYN_CUSTOM_56_FPD8159.jpg",
      title: "ODYN CUSTOM",
    },
    {
      id: 31,
      link: "/configurator/31",
      imgSrc: "thumbnails/STELLAR_56_MAD7997.jpg",
      title: "STELLAR",
    },
    {
      id: 32,
      link: "/configurator/32",
      imgSrc: "thumbnails/PC-DC-LIGHT_FPD7619.jpg",
      title: "PC/DC",
    },
    {
      id: 33,
      link: "/configurator/33",
      imgSrc: "thumbnails/Windpointe_AB.jpg",
      title: "WINDPOINTE",
    },
    {
      id: 34,
      link: "/configurator/34",
      imgSrc: "thumbnails/arden.jpg",
      title: "ARDEN",
    },
    {
      id: 35,
      link: "/configurator/35",
      imgSrc: "thumbnails/AVIARA_FPD6725.jpg",
      title: "AVIARA",
    },
    {
      id: 36,
      link: "/configurator/36",
      imgSrc: "thumbnails/ISLANDER DC BPP1 MAD3250.jpg",
      title: "ISLANDER DC",
    },
    {
      id: 37,
      link: "/configurator/37",
      imgSrc: "thumbnails/LENZI-FPD7060.jpg",
      title: "LENZI",
    },
    {
      id: 38,
      link: "/configurator/38",
      imgSrc: "thumbnails/STARBOARD-LIGHT_FP6752.jpg",
      title: "STARBOARD",
    },
    {
      id: 39,
      link: "/configurator/39",
      imgSrc: "thumbnails/TORCHAIRE_52_FPD8570_Light.jpg",
      title: "TORCHAIRE",
    },
    {
      id: 40,
      link: "/configurator/40",
      imgSrc: "thumbnails/AIREFLUSH_LP6804.jpg",
      title: "AIREFLUSH",
    },
    {
      id: 41,
      link: "/configurator/41",
      imgSrc: "thumbnails/YARDLEY_LP6821L.jpg",
      title: "YARDLEY",
    },
    {
      id: 42,
      link: "/configurator/42",
      imgSrc: "thumbnails/EIGHTYFOUR_LP6827.jpg",
      title: "EIGHTYFOUR",
    },
    {
      id: 43,
      link: "/configurator/43",
      imgSrc: "thumbnails/KWINT_LP6834.jpg",
      title: "KWINT",
    },
    {
      id: 44,
      link: "/configurator/44",
      imgSrc: "thumbnails/SixtyFour_LP6864.jpg",
      title: "SIXTYFOUR",
    },
    {
      id: 45,
      link: "/configurator/45",
      imgSrc: "thumbnails/RADIUS_LP7614.jpg",
      title: "RADIUS",
    },
    {
      id: 46,
      link: "/configurator/46",
      imgSrc: "thumbnails/Aire_Duo_LP8066.jpg",
      title: "AIRE DUO",
    },
    {
      id: 47,
      link: "/configurator/47",
      imgSrc: "thumbnails/AIRE_DROP_LP8068.jpg",
      title: "AIRE DROP",
    },
    {
      id: 48,
      link: "/configurator/48",
      imgSrc: "thumbnails/Slinger_V2_LP8147S.jpg",
      title: "SLINGER",
    },
    {
      id: 49,
      link: "/configurator/49",
      imgSrc: "thumbnails/ALL_WEATHER_PIlon_LP8177.jpg",
      title: "ALL WEATHER",
    },
    {
      id: 50,
      link: "/configurator/50",
      imgSrc: "thumbnails/PROP_LP8333.jpg",
      title: "PROP",
    },
    {
      id: 51,
      link: "/configurator/51",
      imgSrc: "thumbnails/BLITZ_LP8377.jpg",
      title: "BLITZ",
    },
    {
      id: 52,
      link: "/configurator/52",
      imgSrc: "thumbnails/Kindred_LP8543.jpg",
      title: "KINDRED",
    },
    {
      id: 53,
      link: "/configurator/53",
      imgSrc: "thumbnails/kute5.jpg",
      title: "KUTE5",
    },
    {
      id: 54,
      link: "/configurator/54",
      imgSrc: "thumbnails/aviara_coastal.jpg",
      title: "AVIARA COASTAL",
    },
    {
      id: 55,
      link: "/configurator/55",
      imgSrc: "thumbnails/yogi.jpg",
      title: "YOGI",
    },
    {
      id: 56,
      link: "/configurator/56",
      imgSrc: "thumbnails/lizza.jpg",
      title: "LIZZA",
    },
    {
      id: 57,
      link: "/configurator/57",
      imgSrc: "thumbnails/pendry_max.jpg",
      title: "Pendry Max",
    },
    {
      id: 58,
      link: "/configurator/58",
      imgSrc: "thumbnails/corke_52.jpg",
      title: "CORKE",
    },
    {
      id: 59,
      link: "/configurator/59",
      imgSrc: "thumbnails/flex.jpg",
      title: "Flex",
    }
  ];

  return (
    <>
      <header className={styles.header}>
        <div className={styles.logo}>
          <img src="blue_logo.png" alt="" />
        </div>
        <div className={styles.page_title_wrapper}>
          <h1 className={styles.page_title}>
            Configure your Fanimation product.
          </h1>
          <p className={styles.page_subtitle}>
            Click on the product and start your configuration.
          </p>
        </div>
      </header>
      <main style={{ maxHeight: 'calc(100vh - 8.75rem)', overflowY: 'auto' }}>
        <div className={styles.gallary}>
          <div className={styles.row}>
            {scenesData &&
              scenesData.map((scenes) => {
                return (
                  <Link
                    key={scenes.id}
                    to={scenes.link}
                    className={styles.thumbnail}
                  >
                    <div className={styles.hideOverflow}>
                      <img
                        className={styles.thumbnail_img}
                        src={scenes.imgSrc}
                        alt={scenes.title}
                      />
                    </div>
                    <div className={styles.name}>{scenes.title}</div>
                  </Link>
                );
              })}
          </div>
        </div>
      </main>
    </>
  );
}
